import React, { Component } from 'react';

import Utils from '../utils/mci-utils';

export default class TagsInput extends Component{

    constructor(props){
        super(props);

        this.state = {
            tags: []
        };
    }

    handleKeyDown = (e) => {
        const { keyCode, target } = e;
        const { tags } = this.state;
        const { name, onTagsUpdate } = this.props;

        let newTag = target.value;

        if(
            keyCode === 13 || /* Enter */ 
            keyCode === 32 || /* Space */ 
            keyCode === 188 /* Comma */
        ){

            if(newTag !== '' && Utils.isEmailAddress(newTag)){
                tags.push(newTag);
                target.value = '';

                this.setState({ tags }, ()=>{ onTagsUpdate(name, tags) });
            }
            else{
                alert('Enter a valid email address');
            }

            e.preventDefault();
            return false;
        }

        if(keyCode === 8 && newTag === '' && tags.length > 0){
            tags.pop();
            
            this.setState({ tags }, ()=>{ onTagsUpdate(name, tags) });
        }
    }

    removeTag = (e) => {
        e.preventDefault();
        
        const { tags } = this.state;
        tags.pop();

        this.setState({ tags });
    }

    render(){
        // console.log(this.state);

        const { tags } = this.state;
        const { placeholder } = this.props;

        return(
            <div className="tag-input" onClick={ ()=>{ this.refs.tagInput.focus() } }>
                { tags.length > 0 ?

                    tags.map((tag, index) => {
                        
                        return(
                            <span className="pill" key={ index }>
                                <span className="tag">{ tag }</span>
                                <a className="remove" onClick={ this.removeTag }>×</a>
                            </span>
                        )
                    })
                :
                    null
                }
                <input 
                    ref="tagInput"
                    placeholder={ placeholder } 
                    type="text"
                    onKeyDown={ this.handleKeyDown }
                    className="new-tag" />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/TagsInput.jsx